<template>
  <div>
    <div>
      <div class="headline text-xs-center mt-3">
        {{ title }}
      </div>

      <v-radio-group v-model="viewMode" row class="my-0 ml-4 pa-0" hide-details>
        <v-radio
          label="Calendar View"
          value="calendar"
          color="success"
        ></v-radio>
        <v-radio label="List View" value="list" color="success"></v-radio>
      </v-radio-group>

      <div
        class="mx-4 mt-1"
        style="display: flex; align-items: center; position: relative;"
      >
        <v-layout row justify-space-between>
          <v-btn
            large
            color="success"
            @click="openNewEventDialog()"
            title="New Event"
          >
            New Event
          </v-btn>
          <v-layout
            v-if="viewMode === 'calendar'"
            row
            justify-center
            style="position: absolute; left: 50%; transform: translateX(-50%);"
          >
            <v-btn
              style="background-color: #fff !important;"
              color="success"
              outline
              @click="$refs.calendar.prev()"
              title="Previous Month"
            >
              <v-icon left>mdi-chevron-left</v-icon>
              Prev
            </v-btn>
            <div class="px-3 mt-3 headline">
              {{ getCurrentMonth() }}
            </div>
            <v-btn
              style="background-color: #fff !important;"
              color="success"
              outline
              @click="$refs.calendar.next()"
              title="Next Month"
            >
              Next
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
          </v-layout>
          <v-btn
            v-if="viewMode === 'calendar'"
            style="background-color: #fff !important; margin-left: 10px;"
            color="success"
            outline
            @click="jumpToTime()"
            title="Jump to Time"
            small
          >
            Jump to Date
          </v-btn>
        </v-layout>
      </div>

      <v-flex v-if="viewMode === 'calendar'" xs12 class="mx-4 mt-0">
        <v-sheet width="100%" style="position: relative;">
          <v-calendar
            style="border: 2px solid #5cb860;"
            v-model="value"
            color="primary"
            ref="calendar"
            :min-weeks="5"
          >
            <template v-slot:day="{ date }">
              <v-icon
                color="success"
                class="day-add-btn"
                :title="
                  'New Event on ' +
                    new Date(date).toLocaleDateString('en-US', {
                      timeZone: 'UTC',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                "
                @click.stop="openNewEventDialogWithDate(date)"
                small
                >mdi-plus-circle</v-icon
              >
              <template
                v-if="calendarEventsMap[date] && calendarEventsMap[date].length"
              >
                <div
                  v-for="event in sortedEvents(date)"
                  :key="event.id"
                  :title="
                    event.active
                      ? 'Event #' + event.id
                      : 'Event #' + event.id + ' (Inactive)'
                  "
                  :class="{
                    'slot-event-active': event.active,
                    'slot-event-inactive': !event.active,
                  }"
                  class="slot-event mb-1"
                  @click="onEventClick(event)"
                >
                  <div class="slot-event-row1">
                    <span class="slot-event-title">{{
                      event.name || null
                    }}</span>
                    <span class="slot-event-time"
                      >{{ formatTime(event.start) }} –
                      {{ formatTime(event.end) }}</span
                    >
                  </div>
                  <div class="slot-event-row2">
                    👥 {{ event.participants.length }} Participant{{
                      event.participants.length > 1 ? "s" : ""
                    }}
                  </div>
                </div>
              </template>
            </template>
          </v-calendar>
          <div
            v-if="initialLoad"
            class="text-xs-center"
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.7); z-index: 10; display: flex; flex-direction: column; align-items: center; justify-content: center;"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
              :width="5"
            ></v-progress-circular>
            <div class="mt-3">Loading...</div>
          </div>
        </v-sheet>
      </v-flex>

      <conference-room-bookings
        v-if="viewMode === 'list'"
        :events="events"
        :processing="processing"
        @delete="daleteEventDialog = true"
        @edit="openEditEventDialog()"
        @selectedEvent="selectedEvent = $event"
      ></conference-room-bookings>

      <v-dialog v-model="jumpDialog" max-width="350" content-class="dialog-top">
        <v-card>
          <v-card-title
            style="background-color: #5cb860; color: white;"
            class="headline"
            >Jump to Date</v-card-title
          >
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-select
                  v-model="jumpMonth"
                  :items="months"
                  item-text="label"
                  item-value="value"
                  label="Month"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-select
                  v-model="jumpYear"
                  :items="years"
                  label="Year"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" small dark @click="jumpDialog = false"
              >Cancel</v-btn
            >

            <v-btn
              color="info"
              @click="goToCurrentMonth()"
              title="Go to Current Date"
              small
              dark
            >
              Today
            </v-btn>

            <v-btn color="success" small dark @click="applyJump()">Go</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="eventDialog" max-width="650">
        <conference-room-booking
          v-if="selectedEvent"
          :selected-event="selectedEvent"
          :processing="processing"
          @close="eventDialog = false"
          @delete="daleteEventDialog = true"
          @edit="openEditEventDialog()"
        ></conference-room-booking>
      </v-dialog>

      <v-dialog v-model="daleteEventDialog" max-width="380">
        <v-card>
          <v-card-title class="headline red lighten-4"
            >Delete Event</v-card-title
          >
          <v-card-text class="pt-3">
            Are you sure you want to delete Event #{{
              selectedEvent && selectedEvent.id
            }}
            ? <br />
            This action cannot be undone !
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              small
              outline
              color="success"
              @click="daleteEventDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              flat
              small
              outline
              color="error"
              :loading="deleteProcessing"
              @click="deleteEvent()"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="newEvent.dialog"
        max-width="700"
        content-class="dialog-top"
        persistent
      >
        <v-form ref="newEventForm">
          <v-card>
            <v-card-title
              style="background-color: #5cb860; color: white;"
              class="headline"
              >New Event
            </v-card-title>

            <v-card-text class="py-0">
              <b>
                Select a date and time and duration to schedule an event
              </b>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm3>
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          newEvent.startDate
                            ? new Date(
                                newEvent.startDate + 'T00:00:00'
                              ).toLocaleDateString()
                            : ''
                        "
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                        :pointer-events="newEvent.startDate ? 'none' : 'auto'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newEvent.startDate"
                      @input="startDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-combobox
                    v-model="newEvent.startTime"
                    :items="timeSlots"
                    label="Start Time"
                    :rules="[rules.required]"
                    prepend-icon="mdi-clock-outline"
                    item-text="text"
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 sm4>
                  <v-select
                    v-model="newEvent.duration"
                    :items="durationOptions"
                    item-text="label"
                    item-value="minutes"
                    label="Duration"
                    prepend-icon="mdi-clock-outline"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <div
                v-if="newEvent.endDate && newEvent.endTime"
                class="caption mb-2"
                style="text-align: right;"
              >
                Ends at
                {{
                  new Date(
                    newEvent.endDate + " " + newEvent.endTime
                  ).toLocaleString()
                }}
              </div>
              <v-text-field
                class="mt-2"
                outline
                v-model="newEvent.topic"
                label="Enter Event Topic"
                :rules="[rules.required]"
              ></v-text-field>
              <v-layout>
                <label>Send Notification: &nbsp; &nbsp; &nbsp; &nbsp;</label>
                <div>
                  <v-layout>
                    <v-checkbox
                      class="ma-0 pa-0 pr-4"
                      v-model="newEvent.sendEmail"
                      label="Email"
                      color="success"
                      hide-details
                    ></v-checkbox>
                    <v-checkbox
                      class="ma-0 pa-0"
                      v-model="newEvent.sendSMS"
                      label="SMS"
                      color="success"
                      hide-details
                    ></v-checkbox>
                  </v-layout>
                </div>
              </v-layout>
              <v-layout row align-center justify-space-between>
                <div>
                  <span
                    v-if="newEvent.sendEmail || newEvent.sendSMS"
                    class="caption grey--text"
                    >Will send a notification to all participants via
                    {{ newEvent.sendEmail ? "Email" : ""
                    }}{{ newEvent.sendEmail && newEvent.sendSMS ? " and " : ""
                    }}{{ newEvent.sendSMS ? "SMS" : "" }}.</span
                  >
                  <span v-else class="caption red--text"
                    >Will not send a notification to any participants.</span
                  >
                </div>
                <v-btn
                  title="Add New External User"
                  flat
                  small
                  color="success"
                  @click="openNewExternalUserDialog()"
                >
                  <v-icon small>mdi-account-plus</v-icon> &nbsp; New User</v-btn
                >
              </v-layout>

              <div
                style="border: 1px solid #ccc; padding-left: 10px; padding-right: 10px; border-radius: 5px; margin-bottom: 10px;"
              >
                <v-layout row align-center class="mt-2">
                  <b>Primary Participant: </b>
                </v-layout>

                <conference-room-all-users
                  v-model="newEvent.user"
                  :external-users="externalUsers"
                  :internal-users="internalUsers"
                  :loading="loading"
                  @update:internalUsers="loadInternalUsers"
                  @update:externalUsers="loadExternalUsers"
                ></conference-room-all-users>
              </div>

              <v-layout row align-center class="my-2">
                <b
                  >Additional Participants: ({{ newEvent.participants.length }})
                </b>
              </v-layout>

              <div
                style="border: 1px solid #ccc; padding-left: 10px; padding-right: 10px; border-radius: 5px; margin-bottom: 10px;"
                v-for="(participant, index) in newEvent.participants"
                :key="index"
                class="participant-row"
              >
                <v-layout row align-center>
                  <v-flex>
                    <conference-room-all-users
                      v-model="participant.user"
                      :external-users="externalUsers"
                      :internal-users="internalUsers"
                      :loading="loading"
                      @update:internalUsers="loadInternalUsers"
                      @update:externalUsers="loadExternalUsers"
                    ></conference-room-all-users>
                  </v-flex>
                  <v-icon
                    class="ml-4"
                    style="cursor: pointer;"
                    color="error"
                    @click="removeParticipant(index)"
                    title="Remove Participant"
                    >mdi-delete</v-icon
                  >
                </v-layout>
              </div>
              <v-layout row justify-end>
                <v-btn
                  title="Add Participant"
                  flat
                  small
                  color="success"
                  @click="addParticipant()"
                >
                  Add Participant
                </v-btn>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                dark
                small
                @click="(newEvent.dialog = false), resetNewEvent()"
                >Cancel</v-btn
              >
              <v-btn
                color="success"
                dark
                small
                @click="saveNewEvent()"
                :loading="processing"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="editEvent.dialog" max-width="700" persistent>
        <v-form ref="editEventForm">
          <v-card>
            <v-card-title
              style="background-color: #5cb860; color: white;"
              class="headline"
            >
              <v-layout row align-center justify-space-between>
                <div>
                  Edit Event &nbsp;&nbsp;<span class="caption">
                    #{{ selectedEvent && selectedEvent.id }}</span
                  >
                </div>
                <div inline-flex align-center>
                  <v-switch
                    v-model="editEvent.isActive"
                    :label="editEvent.isActive ? 'Active' : 'Inactive'"
                    color="white"
                    hide-details
                    class="ma-0 pa-0 white-label-switch"
                  ></v-switch>
                </div>
              </v-layout>
            </v-card-title>

            <v-card-text class="py-0">
              <b>
                Select a date and time and duration to schedule an event
              </b>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm3>
                  <v-menu :close-on-content-click="true" offset-y full-width>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          editEvent.startDate
                            ? new Date(
                                editEvent.startDate + 'T00:00:00'
                              ).toLocaleDateString()
                            : ''
                        "
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                        :pointer-events="editEvent.startDate ? 'none' : 'auto'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editEvent.startDate"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-combobox
                    v-model="editEvent.startTime"
                    :items="timeSlots"
                    label="Start Time"
                    :rules="[rules.required]"
                    prepend-icon="mdi-clock-outline"
                    item-text="text"
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 sm4>
                  <v-select
                    v-model="editEvent.duration"
                    :items="durationOptions"
                    item-text="label"
                    item-value="minutes"
                    label="Duration"
                    prepend-icon="mdi-clock-outline"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
              <div
                v-if="editEvent.endDate && editEvent.endTime"
                class="caption mb-2"
                style="text-align: right;"
              >
                Ends at
                {{
                  new Date(
                    editEvent.endDate + " " + editEvent.endTime
                  ).toLocaleString()
                }}
              </div>
              <v-text-field
                class="mt-2"
                outline
                v-model="editEvent.topic"
                label="Enter Event Topic"
                :rules="[rules.required]"
              ></v-text-field>
              <!-- <v-layout>
                <label>Send Notification: &nbsp; &nbsp; &nbsp; &nbsp;</label>

                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="editEvent.sendEmail"
                  label="Email"
                  color="success"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  class="ma-0 pa-0"
                  v-model="editEvent.sendSMS"
                  label="SMS"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-layout> -->
              <!-- <span
                v-if="editEvent.sendEmail || editEvent.sendSMS"
                class="caption grey--text"
                >Will send a notification to all participants via
                {{ editEvent.sendEmail ? "Email" : ""
                }}{{ editEvent.sendEmail && editEvent.sendSMS ? " and " : ""
                }}{{ editEvent.sendSMS ? "SMS" : "" }}.</span
              >
              <span v-else class="caption red--text"
                >Will not send a notification to any participants.</span
              > -->

              <div
                style="border: 1px solid #ccc; padding-left: 10px; padding-right: 10px; border-radius: 5px; margin-bottom: 10px;"
              >
                <v-layout row align-center class="mt-2">
                  <b>Primary Participant: </b>
                </v-layout>

                <div>
                  <conference-room-all-users
                    v-model="editEvent.user"
                    :external-users="externalUsers"
                    :internal-users="internalUsers"
                    :loading="loading"
                    @update:internalUsers="loadInternalUsers"
                    @update:externalUsers="loadExternalUsers"
                  ></conference-room-all-users>
                </div>
              </div>

              <v-layout row align-center class="my-2">
                <b
                  >Additional Participants: ({{
                    editEvent.participants.length
                  }})
                </b>
              </v-layout>

              <div
                style="border: 1px solid #ccc; padding-left: 10px; padding-right: 10px; border-radius: 5px; margin-bottom: 10px;"
                v-for="(participant, index) in editEvent.participants"
                :key="index"
                class="participant-row"
              >
                <v-layout row align-center>
                  <v-flex>
                    <conference-room-all-users
                      v-model="participant.user"
                      :external-users="externalUsers"
                      :internal-users="internalUsers"
                      :loading="loading"
                      @update:internalUsers="loadInternalUsers"
                      @update:externalUsers="loadExternalUsers"
                    ></conference-room-all-users>
                  </v-flex>
                  <v-icon
                    class="ml-4"
                    style="cursor: pointer;"
                    color="error"
                    @click="removeEditParticipant(index)"
                    title="Remove Participant"
                    >mdi-delete</v-icon
                  >
                </v-layout>
              </div>
              <v-layout row justify-end>
                <v-btn
                  title="Add Participant"
                  flat
                  small
                  color="success"
                  @click="addEditParticipant()"
                >
                  Add Participant
                </v-btn>
              </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                dark
                small
                @click="(editEvent.dialog = false), resetEditEvent()"
                >Cancel</v-btn
              >
              <v-btn
                color="success"
                :dark="!isEditEventInvalid"
                small
                :disabled="isEditEventInvalid"
                @click="editEvent.notificationDialog = true"
                :loading="processing"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog
        v-if="editEvent.notificationDialog"
        v-model="editEvent.notificationDialog"
        max-width="440"
        persistent
      >
        <v-card>
          <v-card-title class="headline success white--text"
            >Send Notification</v-card-title
          >
          <v-card-text>
            <p>Select the notification methods to send to the participants.</p>
            <v-layout column>
              <v-checkbox
                v-model="editEvent.sendEmail"
                label="Email"
                color="success"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="editEvent.sendSMS"
                label="SMS"
                color="success"
                hide-details
              ></v-checkbox>
            </v-layout>
            <span
              v-if="editEvent.sendEmail || editEvent.sendSMS"
              class="caption red--text"
              >Will send a updated event notification
              <b>to all participants</b> via
              {{ editEvent.sendEmail ? "Email" : ""
              }}{{ editEvent.sendEmail && editEvent.sendSMS ? " and " : ""
              }}{{ editEvent.sendSMS ? "SMS" : "" }}.</span
            >
            <span v-else class="caption grey--text"
              >Will not send a notification to any participants.</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              dark
              color="default"
              @click="editEvent.notificationDialog = false"
              >Back</v-btn
            >
            <v-btn color="success" dark small @click="initiateUpdateEvent"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="newExternalUser.dialog" persistent max-width="400">
        <v-form ref="newExternalUserForm">
          <v-card>
            <v-card-title class="headline green lighten-4"
              >New External User</v-card-title
            >
            <v-card-text class="pb-0">
              <v-text-field
                v-model="newExternalUser.fullName"
                label="Name"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                v-model="newExternalUser.email"
                label="Email"
                :rules="[rules.email]"
              ></v-text-field>
              <v-text-field
                v-model="newExternalUser.phoneNumber"
                label="Phone Number"
                :rules="[rules.phone]"
              ></v-text-field>
            </v-card-text>
            <span
              class="ml-3"
              style="color: red; font-size: 12px;"
              v-if="
                !newExternalUser.fullName ||
                  (!newExternalUser.email && !newExternalUser.phoneNumber)
              "
              >Please fill in name and at least one contact detail</span
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                outline
                small
                @click="resetNewExternalUser()"
                >Cancel</v-btn
              >
              <v-btn
                color="success"
                outline
                small
                @click="saveNewExternalUser()"
                :loading="newExternalUser.processing"
                :disabled="
                  !newExternalUser.fullName ||
                    (!newExternalUser.email && !newExternalUser.phoneNumber)
                "
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ConferenceRoomBooking from "./ConferenceRoomBooking.vue";
import ConferenceRoomBookings from "./ConferenceRoomBookings.vue";
import ConferenceRoomAllUsers from "./ConferenceRoomAllUsers.vue";

export default {
  metaInfo() {
    return {
      title: `${this.title}`,
    };
  },
  name: "ConferenceRoomScheduler",
  components: {
    ConferenceRoomBooking,
    ConferenceRoomBookings,
    ConferenceRoomAllUsers,
  },
  data: () => ({
    startDateMenu: false,
    initialLoad: false,
    title: "Conference Room Scheduler",
    viewMode: "calendar",
    listURL: "",
    value: moment().format("YYYY-MM-DD"),
    events: [],
    eventDialog: false,
    selectedEvent: null,
    jumpDialog: false,
    jumpMonth: moment().month() + 1,
    jumpYear: moment().year(),

    months: [
      { label: "January", value: 1 },
      { label: "February", value: 2 },
      { label: "March", value: 3 },
      { label: "April", value: 4 },
      { label: "May", value: 5 },
      { label: "June", value: 6 },
      { label: "July", value: 7 },
      { label: "August", value: 8 },
      { label: "September", value: 9 },
      { label: "October", value: 10 },
      { label: "November", value: 11 },
      { label: "December", value: 12 },
    ],
    years: Array.from({ length: 10 }, (_, i) => moment().year() - 2 + i),

    timeSlots: (() => {
      const slots = [];
      for (let h = 6; h <= 23; h++) {
        for (let m = 0; m < 60; m += 15) {
          const hh = String(h).padStart(2, "0");
          const mm = String(m).padStart(2, "0");
          const val = `${hh}:${mm}`;
          const hour12 = h % 12 === 0 ? 12 : h % 12;
          const ampm = h < 12 ? "AM" : "PM";
          const label = `${hour12}:${mm} ${ampm}`;
          slots.push({ text: label, value: val });
        }
      }
      return slots;
    })(),

    durationOptions: [
      { label: "15 Min", minutes: 15 },
      { label: "30 Min", minutes: 30 },
      { label: "45 Min", minutes: 45 },
      { label: "1 Hour", minutes: 60 },
      { label: "1.5 Hours", minutes: 90 },
      { label: "2 Hours", minutes: 120 },
      { label: "2.5 Hours", minutes: 150 },
      { label: "3 Hours", minutes: 180 },
      { label: "3.5 Hours", minutes: 210 },
      { label: "4 Hours", minutes: 240 },
      { label: "4.5 Hours", minutes: 270 },
      { label: "5 Hours", minutes: 300 },
      { label: "5.5 Hours", minutes: 330 },
      { label: "6 Hours", minutes: 360 },
      { label: "6.5 Hours", minutes: 390 },
      { label: "7 Hours", minutes: 420 },
      { label: "7.5 Hours", minutes: 450 },
      { label: "8 Hours", minutes: 480 },
      { label: "8.5 Hours", minutes: 510 },
      { label: "9 Hours", minutes: 540 },
      { label: "10 Hours", minutes: 600 },
      { label: "11 Hours", minutes: 660 },
      { label: "12 Hours", minutes: 720 },
    ],

    newEvent: {
      dialog: false,
      user: null,
      topic: "",
      sendEmail: true,
      sendSMS: true,
      participants: [],
      startDate: "",
      startTime: "",
      duration: null,
      endDate: "",
      endTime: "",
      startDateTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      endDateTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    },

    editEvent: {
      dialog: false,
      user: null,
      conferenceRoomUserID: null,
      topic: null,
      sendEmail: false,
      sendSMS: false,
      participants: [],
      duration: null,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      startDateTime: null,
      endDateTime: null,
      isActive: true,
      notificationDialog: false,
    },
    newExternalUser: {
      dialog: false,
      fullName: "",
      email: "",
      phoneNumber: "",
      processing: false,
    },
    daleteEventDialog: false,
    deleteProcessing: false,

    internalUsers: [],
    externalUsers: [],
    loading: false,
    processing: false,
    rules: {
      required: (value) => !!value || "Required.",
      email: (v) =>
        !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Invalid email address",
      phone: (v) =>
        !v ||
        /^\d{10,11}$/.test(v) ||
        "Phone number must be a valid US number, 10 or 11 digits without dashes or parentheses",
      timeFormat: (v) =>
        !v || /^([01]\d|2[0-3]):([0-5]\d)$/.test(v) || "Invalid time format",
    },
  }),

  watch: {
    "newEvent.startDate"() {
      this.updateEndTime();
    },
    "newEvent.startTime"() {
      this.updateEndTime();
    },
    "newEvent.duration"() {
      this.updateEndTime();
    },
    "editEvent.startDate"() {
      this.updateEditEventEndTime();
    },
    "editEvent.startTime"() {
      this.updateEditEventEndTime();
    },
    "editEvent.duration"() {
      this.updateEditEventEndTime();
    },
  },

  computed: {
    isEditEventInvalid() {
      const e = this.editEvent;
      if (!e.startDate || !e.startTime || !e.duration || !e.topic || !e.user)
        return true;
      return e.participants.some((p) => !p.user);
    },
    calendarEventsMap() {
      const map = {};
      this.events.forEach((e) => {
        const key = moment(e.start).format("YYYY-MM-DD");
        (map[key] = map[key] || []).push(e);
      });
      return map;
    },
  },
  methods: {
    filterInternalUsers(item, queryText) {
      const q = queryText.toLowerCase();
      return (
        (item.userName || "").toLowerCase().includes(q) ||
        (item.phoneNumber || "").trim().includes(q) ||
        (item.email || "").toLowerCase().includes(q) ||
        (item.name || "").toLowerCase().includes(q)
      );
    },
    filterExternalUsers(item, queryText) {
      const q = queryText.toLowerCase();
      return (
        (item.fullName || "").toLowerCase().includes(q) ||
        (item.phoneNumber || "").trim().includes(q) ||
        (item.email || "").toLowerCase().includes(q)
      );
    },
    getCurrentMonth() {
      return this.value
        ? moment(this.value).format("MMMM YYYY")
        : moment().format("MMMM YYYY");
    },
    goToCurrentMonth() {
      this.value = moment().format("MMMM YYYY");
      this.jumpDialog = false;
    },
    jumpToTime() {
      this.jumpMonth = moment(this.value).month() + 1;
      this.jumpYear = moment(this.value).year();
      this.jumpDialog = true;
    },
    applyJump() {
      this.value = moment({
        year: this.jumpYear,
        month: this.jumpMonth - 1,
        day: 1,
      }).format("YYYY-MM-DD");
      this.jumpDialog = false;
    },

    formatTime(val) {
      return val ? moment(val).format("hh:mm A") : "";
    },
    sortedEvents(date) {
      if (!this.calendarEventsMap[date]) return [];
      return this.calendarEventsMap[date]
        .slice()
        .sort((a, b) => moment(a.start) - moment(b.start));
    },
    onEventClick(event) {
      this.selectedEvent = event;
      this.eventDialog = true;
    },
    async loadInternalUsers() {
      this.loading = true;
      try {
        const response = await this.$http.get("/odata/users");
        this.internalUsers = response.value.map((user) => ({
          ...user,
          userType: "internal",
        }));
        this.internalUsers.map((user) => {
          if (
            !user.email &&
            user.userName &&
            user.userName.includes("@") &&
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.userName)
          ) {
            user.email = user.userName;
          }
        });
      } catch (error) {}
      this.loading = false;
    },

    async loadExternalUsers() {
      this.loading = true;
      try {
        const response = await this.$http.get(
          "/api/ConferenceRoomUsers/GetAll"
        );
        this.externalUsers = response.map((user) => ({
          ...user,
          userType: "external",
        }));
      } catch (error) {}
      this.loading = false;
    },

    async openNewEventDialog() {
      this.resetNewEvent();
      this.newEvent.dialog = true;
      if (this.internalUsers.length === 0) {
        this.loadInternalUsers();
      }
      if (this.externalUsers.length === 0) {
        this.loadExternalUsers();
      }
    },

    async openNewEventDialogWithDate(date) {
      await this.openNewEventDialog();
      this.newEvent.startDate = date;
    },

    addParticipant() {
      this.newEvent.participants.push({ user: "" });
    },
    addEditParticipant() {
      this.editEvent.participants.push({ user: "" });
    },
    removeParticipant(index) {
      this.newEvent.participants.splice(index, 1);
    },
    removeEditParticipant(index) {
      this.editEvent.participants.splice(index, 1);
    },
    startTimeString(startTime) {
      return startTime && typeof startTime === "object"
        ? startTime.value
        : startTime;
    },
    updateEndTime() {
      const { startDate, startTime, duration } = this.newEvent;
      const startTimeStr = this.startTimeString(startTime);
      if (startDate && duration) {
        const end = moment(startDate + " " + startTimeStr).add(
          duration,
          "minutes"
        );
        this.newEvent.endDate = end.format("YYYY-MM-DD");
        this.newEvent.endTime = end.format("HH:mm");
      } else {
        this.newEvent.endDate = "";
        this.newEvent.endTime = "";
      }
    },

    updateEditEventEndTime() {
      const { startDate, startTime, duration } = this.editEvent;
      const startTimeStr = this.startTimeString(startTime);
      if (startDate && duration) {
        const end = moment(startDate + " " + startTimeStr).add(
          duration,
          "minutes"
        );
        this.editEvent.endDate = end.format("YYYY-MM-DD");
        this.editEvent.endTime = end.format("HH:mm");
      } else {
        this.editEvent.endDate = "";
        this.editEvent.endTime = "";
      }
    },

    async resetNewEvent() {
      await this.$refs.newEventForm.reset();
      this.newEvent.user = null;
      this.newEvent.topic = "";
      this.newEvent.startDate = "";
      this.newEvent.startTime = "";
      this.newEvent.duration = null;
      this.newEvent.endDate = "";
      this.newEvent.endTime = "";
      this.newEvent.sendEmail = true;
      this.newEvent.sendSMS = true;
      this.newEvent.participants = [];
    },

    async saveNewEvent() {
      if (!this.$refs.newEventForm.validate()) return;
      const payload = {
        username:
          this.newEvent.user.userType === "internal"
            ? this.newEvent.user.userName
            : null,

        conferenceRoomUserID:
          this.newEvent.user.userType === "external"
            ? this.newEvent.user.id
            : null,

        startTime:
          this.newEvent.startDate +
          " " +
          this.startTimeString(this.newEvent.startTime),

        endTime: this.newEvent.endDate + " " + this.newEvent.endTime,

        description: this.newEvent.topic,

        participants: this.newEvent.participants.map((p) => ({
          username: p.user.userType === "internal" ? p.user.userName : null,
          conferenceRoomUserID:
            p.user.userType === "external" ? p.user.id : null,
        })),
        notification: {
          sendEmail: this.newEvent.sendEmail,
          sendSMS: this.newEvent.sendSMS,
        },
      };

      try {
        this.processing = true;
        await this.$http.post("api/ConferenceRoomBookings/create", payload);
        this.$notify({
          text: "Event saved successfully",
          group: "notification",
          type: "success",
        });
        this.loadEvents();
        this.newEvent.dialog = false;
        this.resetNewEvent();
        this.processing = false;
      } catch (error) {
        this.processing = false;
        this.$notify({
          text: "The selected time range is not available for this date",
          group: "notification",
          type: "error",
        });
      }
    },

    async deleteEvent() {
      this.deleteProcessing = true;
      try {
        await this.$http.post(
          "api/ConferenceRoomBookings/Delete/" + this.selectedEvent.id
        );

        this.eventDialog = false;
        this.selectedEvent = null;
        await this.loadEvents();
        this.daleteEventDialog = false;
        this.$notify({
          text: "Event deleted successfully",
          group: "notification",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          text: "Error deleting event",
          group: "notification",
          type: "error",
        });
      }
      this.deleteProcessing = false;
    },

    async loadEvents() {
      const response = await this.$http.get(
        "api/ConferenceRoomBookings/GetAll"
      );
      this.events = response.map((b) => ({
        id: b.bookingID,
        conferenceRoomUserID: b.conferenceRoomUserID,
        username: b.username || null,
        name: b.username
          ? b.participants.find((p) => p.username == b.username).adminPortalUser
              .name || b.username
          : b.participants.find(
              (p) => p.conferenceRoomUserID == b.conferenceRoomUserID
            ).conferenceRoomUser.fullName,
        start: b.startTime,
        end: b.endTime,
        active: b.isActive,
        PIN: b.pin,
        createdBy: b.createdBy,
        createdOn: b.createdOn,
        participants: b.participants.map((p) => {
          return {
            name:
              (p.adminPortalUser && p.adminPortalUser.name) ||
              p.username ||
              (p.conferenceRoomUser && p.conferenceRoomUser.fullName),
            username: p.username || null,
            id: p.conferenceRoomUser ? p.conferenceRoomUser.id : null,
          };
        }),
        topic: b.description,
      }));
    },

    async initiateUpdateEvent() {
      this.editEvent.notificationDialog = false;
      this.editEvent.start =
        this.editEvent.startDate +
        " " +
        this.startTimeString(this.editEvent.startTime);
      this.editEvent.end =
        this.editEvent.endDate +
        " " +
        this.startTimeString(this.editEvent.endTime);

      const isExternal =
        this.editEvent.user && this.editEvent.user.userType === "external";

      const updatedEvent = {
        id: this.selectedEvent.id,
        conferenceRoomUserID: isExternal ? this.editEvent.user.id : null,
        name: isExternal ? null : this.editEvent.user.userName,
        start: this.editEvent.start,
        end: this.editEvent.end,
        isActive: this.editEvent.isActive,
        topic: this.editEvent.topic,
        participants: this.editEvent.participants,
        startTime: this.startTimeString(this.editEvent.startTime),
        endTime: this.editEvent.endTime,
        notification: {
          sendEmail: this.editEvent.sendEmail,
          sendSMS: this.editEvent.sendSMS,
        },
      };
      await this.updateEvent(updatedEvent);
      this.editEvent.dialog = false;
      this.selectedEvent = this.events.find((e) => e.id === updatedEvent.id);
      this.resetEditEvent();
    },

    async updateEvent(event) {
      try {
        this.processing = true;
        await this.$http.post("api/ConferenceRoomBookings/Update/", {
          ID: event.id,
          ConferenceRoomUserID: event.conferenceRoomUserID,
          Username: event.conferenceRoomUserID ? null : event.name,
          StartTime: event.start,
          EndTime: event.end,
          Description: event.topic,
          IsActive: event.isActive,
          Participants: event.participants.map((p) => {
            if (p.user && p.user.userType === "internal") {
              return {
                Username: p.user.userName,
              };
            } else {
              return {
                ConferenceRoomUserID: p.user.id,
              };
            }
          }),
          Notification: event.notification,
        });
        await this.loadEvents();
        this.$notify({
          text: "Event updated successfully",
          group: "notification",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          text: "Error updating event",
          group: "notification",
          type: "error",
        });
      }
      this.processing = false;
    },

    async openEditEventDialog() {
      this.resetEditEvent();
      this.processing = true;
      if (this.internalUsers.length === 0) {
        await this.loadInternalUsers();
      }
      if (this.externalUsers.length === 0) {
        await this.loadExternalUsers();
      }

      //   this.editEvent.name = this.selectedEvent.name;
      this.editEvent.conferenceRoomUserID = this.selectedEvent.conferenceRoomUserID;
      this.editEvent.topic = this.selectedEvent.topic;

      this.editEvent.user =
        this.selectedEvent.username !== null
          ? this.internalUsers.find(
              (u) => u.userName === this.selectedEvent.username
            )
          : this.externalUsers.find(
              (u) => u.id === this.selectedEvent.conferenceRoomUserID
            );

      this.editEvent.participants = this.selectedEvent.participants.map((p) => {
        return {
          user:
            p.id === null
              ? this.internalUsers.find((u) => u.userName === p.username)
              : this.externalUsers.find((u) => u.id === p.id),
        };
      });

      const primaryParticipant =
        this.selectedEvent.username !== null
          ? this.editEvent.participants.find(
              (p) => p.user.userName === this.editEvent.user.userName
            )
          : this.editEvent.participants.find(
              (p) => p.user.id === this.editEvent.conferenceRoomUserID
            );

      if (primaryParticipant) {
        this.editEvent.participants.splice(
          this.editEvent.participants.indexOf(primaryParticipant),
          1
        );
      }

      this.editEvent.startDate = this.selectedEvent.start.split("T")[0];
      this.editEvent.endDate = this.selectedEvent.end.split("T")[0];

      const startTimeStr = this.selectedEvent.start
        .split("T")[1]
        .substring(0, 5);
      this.editEvent.startTime =
        this.timeSlots.find((s) => s.value === startTimeStr) || startTimeStr;
      this.editEvent.endTime = this.selectedEvent.end.split("T")[1];

      this.editEvent.duration = moment(this.selectedEvent.end).diff(
        moment(this.selectedEvent.start),
        "minutes"
      );
      this.editEvent.isActive = this.selectedEvent.active;

      this.editEvent.dialog = true;
      this.processing = false;
    },
    resetEditEvent() {
      this.$refs.editEventForm.resetValidation(true);
      this.editEvent = {
        dialog: false,
        user: null,
        conferenceRoomUserID: null,
        topic: null,
        sendEmail: false,
        sendSMS: false,
        participants: [],
        duration: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        startDateTime: null,
        endDateTime: null,
        isActive: true,
        notificationDialog: false,
      };
    },
    async saveNewExternalUser() {
      if (!this.$refs.newExternalUserForm.validate(true)) return;
      this.newExternalUser.processing = true;
      try {
        await this.$http.post(
          "api/ConferenceRoomUsers/Create",
          this.newExternalUser
        );
        this.$notify({
          text: "User created successfully",
          group: "notification",
          type: "success",
        });
        this.resetNewExternalUser();
        this.loadExternalUsers();
      } catch (error) {
        this.$notify({
          text: "Error creating user",
          group: "notification",
          type: "error",
        });
      }
    },

    openNewExternalUserDialog() {
      this.resetNewExternalUser();
      this.newExternalUser.dialog = true;
    },

    resetNewExternalUser() {
      this.newExternalUser.dialog = false;
      this.newExternalUser.fullName = "";
      this.newExternalUser.email = "";
      this.newExternalUser.phoneNumber = "";
      this.newExternalUser.processing = false;
      this.$refs.newExternalUserForm.resetValidation(true);
    },
  },

  async created() {
    this.initialLoad = true;
    await this.loadEvents();
    this.initialLoad = false;
  },
};
</script>

<style scoped>
.slot-event-active,
.slot-event-inactive {
  font-size: 12px;
  padding: 6px 10px;
  margin: 2px 3px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}
.slot-event-active {
  background-color: #eaf4ea !important;
}
.slot-event-inactive {
  background-color: #f0f0f0 !important;
  opacity: 0.5;
}
.slot-event:hover {
  transform: scale(0.97);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.slot-event-row1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
}
.slot-event-title {
  font-weight: 600;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.slot-event-inactive .slot-event-title {
  color: #9e9e9e;
  text-decoration: line-through;
}
.slot-event-time {
  color: #272424;
  white-space: nowrap;
  font-size: 12px;
}
.slot-event-row2 {
  color: #666;
  font-size: 10px;
  margin-top: 2px;
}
</style>

<style>
.dialog-top {
  align-self: flex-start;
  margin-top: 80px;
}
.v-calendar-weekly__day {
  min-height: 170px;
  position: relative;
}
.day-add-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  opacity: 0;
  transition: opacity 0.15s ease;
  cursor: pointer;
  z-index: 1;
}
.v-calendar-weekly__day:hover .day-add-btn {
  opacity: 1;
}
.white-label-switch .v-label {
  color: white !important;
}
</style>
